module.exports = __webpack_public_path__ + "img/ic_paypal_payment-method-dark.05b5bcd.svg";